import React, { useState, useEffect, useContext } from 'react';
import { LykioContext } from '../routing/LykioAuthorizedRoute';
import axios from 'axios';
import Modal from 'react-bootstrap/Modal';
import {
	AUTHORIZED_URL_PREFIX,
    GET_ACTIVE_TENANT_USERS,
	ROOMS_URL,
    CREATE_ROOM_URL,
    GET_ROOM_USERS,
    REMOVE_USER_FROM_ROOM_URL,
    ADD_ROOM_USERS_URL,    
    NOTIFICATION_SEVERITY_SUCCESS,
	NOTIFICATION_SEVERITY_WARNING,    
    SAVE_PROGRESS_DATA_USERID_URL,
	AxiosConfig,
} from '../../Utils/Constants';
import t from "../../Utils/Translation";
import LykioButton from "../common/LykioButton";
import Loading from '../common/Loading';
import { notify, pleaseRefreshError } from '../../Utils/Notificator';
import {Autocomplete, Box, Container, Grid, TextField, Typography,
        DialogContent, DialogTitle, Button} from "@mui/material";
import Checkbox from '@mui/material/Checkbox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Table from 'react-bootstrap/Table';


const Room = () => {
    const context = useContext(LykioContext);
    const assignAdminRole = localStorage.getItem('localca')==='true' ? true : false;
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const [showAddUsersModal, setShowAddUsersModal] = useState(false);
    const handleCloseAddUsersModal = () => setShowAddUsersModal(false);
    const [showActivityScoresModal, setShowActivityScoresModal] = useState(false);
    const handleCloseActivityScoresModal = () => setShowActivityScoresModal(false);
    const handleShowAddUsersModal = () => setShowAddUsersModal(true);

    const [ isLoading, setIsLoading ] = useState(false);
    const [ users, setUsers ] = useState([]);
    const [ rooms, setRooms ] = useState([]);
    const [ selectedRoom, setSelectedRoom ] = useState();
    const [ selectedUsers, setSelectedUsers ] = useState([]);
    const [ roomName, setRoomName ] = useState('');
    const [ roomUsers, setRoomUsers ] = useState([]);
    const [ usersNotInRoom, setUsersNotInRoom ] = useState([]);
    const [ isUploadNewRoomButtonDisabled, setIsUploadNewRoomButtonDisabled ] = useState(false);
    const [ userForEdit, setUserForEdit ] = useState([]);

    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize='small'/>

    const fetchUsers = async () => {
        console.log('fetchUsers');
        try {
            const { data } = await axios.get(`${AUTHORIZED_URL_PREFIX}${GET_ACTIVE_TENANT_USERS}`, AxiosConfig());

            const usersWithoutTeacher = data.tenantUsers.filter(
                    (user) => user.role !== "teacher" && user.id !== (context && context.userDetails ? context.userDetails.id : localStorage.getItem("user").id));

            console.log("usersWithoutTeacher: " + JSON.stringify(usersWithoutTeacher));
            setUsers(usersWithoutTeacher);
            if (!data.success) {
                notify(pleaseRefreshError);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const fetchRoomsData = async () => {
        console.log("fetchRoomsData");
        try {
            const { data } = await axios.get(`${AUTHORIZED_URL_PREFIX}${ROOMS_URL}`, AxiosConfig());
            const fetchedRooms = data.rooms;
            const sortedRooms = [...fetchedRooms].sort((a, b) => a.name.localeCompare(b.name));
            
            console.log("sortedRooms: " + JSON.stringify(sortedRooms));
            setRooms(sortedRooms);

            if (selectedRoom === null || selectedRoom === undefined) {
                setSelectedRoom(sortedRooms.length > 0 ? sortedRooms[0] : null);
              }

            setIsLoading(false);
            if (!data.success) {
                notify(pleaseRefreshError);
            }
        } catch (error) {
            console.log(error);
            notify(pleaseRefreshError);
        }
    }
    
    const fetchUserData = async (userId) => {
        console.log("fetchUserData");
        try {
            const response = await axios.get(
                `${AUTHORIZED_URL_PREFIX}/user/getData/${userId}`,
                AxiosConfig()
            );

            if (response.data.userCustomData && response.data.progressData) {
                return response.data;
            }
            else if (response.data.userData) {
                return response.data.userData;
            } else {
                console.error('Unexpected data format:', response.data);
                return null;
            }
        } catch (error) {
            console.error('Error fetching user data:', error);
            notify(pleaseRefreshError);
            return null;
        }
    };

    useEffect(() => {
        console.log("fetcData");
        const fetchData = async () => {
            try {
                await fetchUsers();
                await fetchRoomsData();
            } catch (error) {
                console.error(error);
                notify(pleaseRefreshError);
            }
        };

        const handleNewRoomCreated = () => {
            fetchRoomsData();
        };
        window.addEventListener('newRoomCreated', handleNewRoomCreated);
        fetchData();
        return () => {
            window.removeEventListener('newRoomCreated', handleNewRoomCreated);
        };
    }, []);
  
    useEffect(() => {
    
        const getRoomUsers = async () => {
            console.log("getRoomUsers");
            try {
                if (selectedRoom) {
                    const { data } = await axios.post(
                        `${AUTHORIZED_URL_PREFIX}${GET_ROOM_USERS}`,
                        { roomId: selectedRoom._id },
                        AxiosConfig()
                    );
                    const { success, roomUsers } = data;
                    console.log("roomUsers.....", roomUsers);
                    if (success) {
                        // Fetch user data for each user
                        const roomUsersWithData = await Promise.all(
                            roomUsers.map(async (user) => {
                                const userData = await fetchUserData(user.id);
                                return { ...user, userData };
                            })
                        );
                        setRoomUsers(roomUsersWithData);
                        console.log("roomUsersWithData.....", roomUsersWithData);
                    } else {
                        console.error("Failed to fetch class users");
                    }
                }
            } catch (error) {
                console.error("Error while fetching class users:", error);
            }
        };

        const handleUserDeletedFromRoom = () => {
            getRoomUsers();
        };

        const handleUsersAddedToRoom = () => {
            getRoomUsers();
        };
    
        window.addEventListener('userAddedToRoom', handleUsersAddedToRoom);
        window.addEventListener('userDeletedFromRoom', handleUserDeletedFromRoom);
        getRoomUsers();
        
        return () => {
            window.removeEventListener('userAddedToRoom', handleUsersAddedToRoom);
            window.removeEventListener('userDeletedFromRoom', handleUserDeletedFromRoom);
        };
    }, [selectedRoom]);
          
    useEffect(() => {
        if (users.length) {            
            const userIdsInRoom = roomUsers.map((user) => user.id);
            const usersNotInThisRoom = users.filter((user) => !userIdsInRoom.includes(user.id));
            setUsersNotInRoom(usersNotInThisRoom);
        }
    }, [users, roomUsers]);

    const handleNewClassSubmit = async (e) => {
        e.preventDefault();
        setIsUploadNewRoomButtonDisabled(false);
        if (roomName==="") {
            notify({
                title: `${t('Class name is missing.')}`,
                severity: NOTIFICATION_SEVERITY_WARNING,
                creationDate: ''
            });
            return;
        }
        try {
            setIsUploadNewRoomButtonDisabled(true);
            const roomData = {
                name: roomName,
                selectedUsers: selectedUsers.map((user) => user.id), 
            };
    
            const response = await axios.post(`${AUTHORIZED_URL_PREFIX}${CREATE_ROOM_URL}`, roomData, AxiosConfig());
    
            if (response.data.success) {
                console.log("Class created successfully!");
                notify({
                    title: `${t('Class created successfully.')}`,
                    severity: NOTIFICATION_SEVERITY_SUCCESS,
                    creationDate: ''
                });
                
                window.dispatchEvent(new Event('newRoomCreated'));
                setShow(false);
                setIsUploadNewRoomButtonDisabled(false);
                setSelectedUsers([]);
            } else {
                console.log("Class creation failed - A class with the same name already exists");
                notify({
                    title: `${t('A class with the same name already exists.')}`,
                    severity: NOTIFICATION_SEVERITY_WARNING,
                    creationDate: ''
                });
                setIsUploadNewRoomButtonDisabled(false);
            }
        } catch (error) {
            console.error("Error while creating a class:", error);
            notify(pleaseRefreshError);
        }
    };
    
    const handleRemoveUser = async (userId) => {
        try {
            const { data } = await axios.post(
                `${AUTHORIZED_URL_PREFIX}${REMOVE_USER_FROM_ROOM_URL}`,
                { roomId: selectedRoom._id, student: userId }, 
                AxiosConfig()
            );
            const { success } = data;

            if (success) {
                window.dispatchEvent(new Event('userDeletedFromRoom'));
                notify({
                    title: `${t('User deleted successfully')}`,
                    severity: NOTIFICATION_SEVERITY_SUCCESS,
                    creationDate: ''
                });
            } else {
                console.error("Failed to delete user");
            }
            
          } catch (error) {
            console.error("Error while fetching room users:", error);
          }
    }

    const handleEditUser = async (userId) => {
        setShowActivityScoresModal(true);
        const user = roomUsers.find(u => u._id === userId);
        setUserForEdit(user);
    };

    const returnUserTaskScore = ({ user, taskId } = {}) => {
        try {
            if (user && user.userData && user.userData.progressData) {
                const task = getTaskFromProgressData(user.userData.progressData, taskId);
                
                if (task && typeof task.score !== 'undefined') {
                    // Find the task title from taskList
                    const taskInfo = taskList.find(t => t.taskId === taskId);
                    const taskTitle = taskInfo ? taskInfo.taskTitle : '';
    
                    console.log(
                        "returnUserTaskScore - taskId:", taskId,
                        "- taskTitle:", taskTitle,
                        "- score:", task.score
                    );
    
                    return task.score;
                }else{
                    console.log("returnUserTaskScore - not found taskId:", taskId);
                    return -1;
                }
            }
        } catch (error) {
            console.error("Error in returnUserTaskScore:", error);
            return -1;
        }
        return -1;
    };

    function getTaskFromProgressData(progressData, taskId) {
        if (!progressData || !progressData.units) {
            return null;
        }
        for (const unit of progressData.units) {
            if (unit.tasks) {
                for (const task of unit.tasks) {
                    if (task.taskId === taskId) {
                        return task;
                    }
                }
            }
        }
        return null;
    }

    const taskList = [
        { taskTitle: "Intensity of emotions", taskId: 10501 },
        { taskTitle: "Expanding Self-Knowledge", taskId: 10502 },
        { taskTitle: "My emotions in daily life", taskId: 10503 },
        { taskTitle: "The journal of emotions", taskId: 10504 },
        { taskTitle: "Life decisions!", taskId: 10505 },
        { taskTitle: "Wheel of fortune", taskId: 10506 },
        { taskTitle: "Read my label", taskId: 10510 },
        { taskTitle: "Question of the Day", taskId: 10511 },
        { taskTitle: "Co-op building \"Toothpick Tower\"", taskId: 10512 },
        { taskTitle: "I would like to hear…", taskId: 10507 },
        { taskTitle: "Class anthem", taskId: 10508 },
        { taskTitle: "Group drawing", taskId: 10509 }
    ];

    const handleSaveUserScores = async () => {
        try {
            console.log("handleSaveUserScores - userForEdit: ", userForEdit.email);
    
            // Recalculate the total score
            let totalScore = 0;
            const progressData = userForEdit.userData.progressData;
            if (progressData && progressData.units) {
                progressData.units.forEach(unit => {
                    if (unit.tasks) {
                        unit.tasks.forEach(task => {
                            if (typeof task.score === 'number') {
                                // Ensure the score is either 0 or 1
                                if (task.score < 0) {
                                    task.score = 0;
                                } else if (task.score > 1) {
                                    task.score = 1;
                                }
                                totalScore += task.score;
                            }
                        });
                    }
                });
            }
    
            // Update userCustomData.score with the total score
            if (userForEdit.userData.userCustomData) {
                userForEdit.userData.userCustomData.score = totalScore;
            } else {
                userForEdit.userData.userCustomData = { score: totalScore };
            }
    
            // Now proceed to save the updated userData
            const response = await axios.post(
                `${AUTHORIZED_URL_PREFIX}${SAVE_PROGRESS_DATA_USERID_URL}/${userForEdit._id}`,
                { userData: userForEdit.userData },
                AxiosConfig()
            );
    
            if (response.data.success) {
                notify({
                    title: `${t('User scores updated successfully.')}`,
                    severity: NOTIFICATION_SEVERITY_SUCCESS,
                    creationDate: ''
                });
                setShowActivityScoresModal(false);
                // Refresh roomUsers to reflect changes
                const updatedRoomUsers = roomUsers.map(user =>
                    user._id === userForEdit._id ? userForEdit : user
                );
                setRoomUsers(updatedRoomUsers);
            } else {
                console.error("Failed to save user scores");
                notify(pleaseRefreshError);
            }
        } catch (error) {
            console.error("Error saving user scores:", error);
            notify(pleaseRefreshError);
        }
    };
    
    return (
        <div  className="lykioccs-main-content">
            <Container>
                {isLoading ? (
                    <Loading />
                ) : (
                    <div>
                        <Box bgcolor={'white'} m={4} p={3} sx={{borderRadius: 2}}>
                            <Typography variant="h5" gutterBottom component="div">{t('Classes Management')}</Typography>
                            <div style={{display:'flex', alignItems:'baseline', flexWrap:'wrap'}}>

                                <div style={{display:'flex', flexDirection: 'column', marginRight:'1rem'}}>
                                    <div style={{display:'flex', flexWrap: 'wrap', alignItems:'baseline'}}>
                                        <Autocomplete
                                            sx={{ width: 300, paddingTop: 5, marginRight: 2 }}
                                            size={'small'}
                                            autoHighlight
                                            options={rooms}
                                            getOptionLabel={(option) => option.name ? option.name : ''}
                                            value={selectedRoom || null}
                                            onChange={(event, val) => {
                                                if(val !== null) {
                                                    setSelectedRoom(val)
                                                }
                                            }}
                                            renderInput={(params) => <TextField {...params} label={t('Select a Class')} />}
                                        />
                                        <div style={{marginRight:'1rem'}}>
                                            <LykioButton style={{marginTop:'0.8rem'}} variant="primary"  
                                                onClick={() => {
                                                    if (!show) {
                                                        setRoomName('');
                                                        setSelectedUsers([]);
                                                        setShow(true);
                                                    }
                                                }}>
                                                {t('New Class')}
                                            </LykioButton>
                                        </div>
                                    </div>

                                    {rooms.length > 0 ? (
                                        <div>
                                            <LykioButton
                                                style={{width:'10rem', margin:'1rem 1rem 1rem 0rem'}}
                                                variant="danger"
                                                onClick={() => setShowAddUsersModal(true)}
                                                >{t('Add New User')}
                                            </LykioButton>
                                        </div>
                                    ) : (
                                        <div>
                                            {t('No classes yet.')}
                                        </div>
                                    )}                                    
                                </div>
                                
                                <div style={{display:'contents'}}>
                                    {show && (
                                        <div className="modal-content modal-dialog" >
                                            <Modal.Header >
                                            <Modal.Title>{t('Create Class')}</Modal.Title>
                                                <button type="button" class="btn-close" aria-label="Close" onClick={handleClose}></button>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <div>
                                                    <DialogContent >
                                                        <Box>
                                                            <TextField
                                                                required
                                                                label={t('Class Name')}
                                                                fullWidth
                                                                sx={{mt:2}}
                                                                onChange={(e) => setRoomName(e.target.value)}
                                                            ></TextField>
                                                        </Box>
                                                    </DialogContent>
                                                </div>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <LykioButton variant="primary" onClick={handleNewClassSubmit} disabled={isUploadNewRoomButtonDisabled}>
                                                    {t('Add')}
                                                </LykioButton>
                                            </Modal.Footer>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {roomUsers.length > 0 && (
                                <div className="lykiocss-material-table my-4">
                                    <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>{t(`Full Name`)}</th>
                                                <th>Email</th>
                                                <th>{t('Score')}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {roomUsers.map((user, index) => (
                                            <tr key={user._id}>
                                                <td style={{paddingLeft:'8px'}}>{index + 1}</td>
                                                <td style={{paddingLeft:'8px'}}>{user.fullName}</td>
                                                <td style={{paddingLeft:'8px'}}>{user.email}</td>
                                                <td style={{paddingLeft:'8px'}}>
                                                    {user.userData && user.userData.userCustomData && user.userData.userCustomData.score !== undefined
                                                        ? user.userData.userCustomData.score
                                                        : 'N/A'}
                                                </td>
                                                <td>
                                                    <LykioButton
                                                        variant="danger"
                                                        onClick={() => handleEditUser(user._id)}
                                                        >{t('Edit')}
                                                    </LykioButton>
                                                    <LykioButton style={{marginLeft:'8px'}}
                                                        variant="danger"
                                                        onClick={() => handleRemoveUser(user._id)}
                                                        >{t('Remove')}
                                                    </LykioButton>
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </Table>
                                </div>
                            )}
                        </Box>
                    </div>
                )}
            </Container>
            <Modal show={showAddUsersModal} onHide={handleCloseAddUsersModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('Add User')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <DialogContent>
                            <Box>
                            <AddUserComponent 
                                usersNotInRoom={usersNotInRoom} 
                                t={t} 
                                handleShowAddUsersModal={handleShowAddUsersModal} 
                                selectedRoom={selectedRoom} 
                            />
                            </Box>
                        </DialogContent>
                    </div>
                </Modal.Body>
            </Modal>
            
            <Modal 
                show={showActivityScoresModal} 
                onHide={handleCloseActivityScoresModal} 
                size="lg"
            >{console.log("Show Modal: Edit user ", userForEdit.email, " Score", )}
                <Modal.Header closeButton>
                    <Modal.Title>{t('Activity Scores')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                {userForEdit && (
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        {taskList.map((task) => {
                            // Define scoreValue here
                            const scoreValue = returnUserTaskScore({ user: userForEdit, taskId: task.taskId });
                            return (
                                <div
                                    key={task.taskId}
                                    style={{ display: 'flex', flexDirection: 'column', margin: '0rem 3rem 3rem 0rem' }}
                                >
                                    <div>
                                        <div>{t(task.taskTitle)}</div>
                                        <div style={{ display: 'flex', alignItems: 'baseline', marginTop: '0.5rem' }}>
                                            <p>{t('Score')}:</p>
                                            <input
                                                style={{
                                                    marginLeft: '5px',
                                                    padding: '2px',
                                                    width: '3.5rem',
                                                    textAlign: 'center',
                                                }}
                                                type="number"
                                                value={scoreValue !== null ? scoreValue : ''}
                                                onChange={(e) => {
                                                    let updatedScore = parseInt(e.target.value, 10);

                                                    // Restrict the value to 0 or 1
                                                    if (isNaN(updatedScore) || updatedScore < 0) {
                                                        updatedScore = 0;
                                                    } else if (updatedScore > 1) {
                                                        updatedScore = 1;
                                                    }

                                                    // Update the user's progressData with the new score
                                                    const updatedUser = JSON.parse(JSON.stringify(userForEdit));
                                                    if (
                                                        updatedUser.userData &&
                                                        updatedUser.userData.progressData
                                                    ) {
                                                        const taskData = getTaskFromProgressData(
                                                            updatedUser.userData.progressData,
                                                            task.taskId
                                                        );
                                                        if (taskData) {
                                                            taskData.score = updatedScore;
                                                        }
                                                    }
                                                    setUserForEdit(updatedUser);
                                                }}
                                                min={0}
                                                max={1}
                                                step={1}
                                            />
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}

                </Modal.Body>
                <Modal.Footer>
                    <LykioButton 
                        variant="primary" 
                        onClick={handleSaveUserScores}
                    >{t('Save')}
                    </LykioButton>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

const AddUserComponent = ({ usersNotInRoom, t, handleShowAddUsersModal, selectedRoom }) => {
    const [email, setEmail] = useState('');
    const addUserToRoom = async (useridToAdd) => {
        try {
            const response = await axios.post(
                `${AUTHORIZED_URL_PREFIX}${ADD_ROOM_USERS_URL}`,
                {
                    roomName: selectedRoom.name,
                    roomId: selectedRoom._id,
                    userIds: [useridToAdd],
                },
                AxiosConfig()
            );

            if (response.data.success) {
                console.log("User ", useridToAdd, " added to the class successfully!");
                notify({
                    title: `${t('User added to the class successfully.')}`,
                    severity: NOTIFICATION_SEVERITY_SUCCESS,
                    creationDate: ''
                });
                
                window.dispatchEvent(new Event('userAddedToRoom'));
            } else {
                console.error("Failed to add user ", useridToAdd, " to the class");
                notify(pleaseRefreshError);
            }
            setEmail('');
            handleShowAddUsersModal(false);            
        } catch (error) {
            console.error("Error adding user to the class:", error);
            notify(pleaseRefreshError);
        }
    }

    const checkEmail = () => {
      const userExists = usersNotInRoom.filter(user => user.email === email);

      if (userExists && userExists.length > 0) {        
        addUserToRoom(userExists[0].id);
      } else {
        notify({
            title: `${t('User email does not exist.')}`,
            severity: NOTIFICATION_SEVERITY_WARNING,
            creationDate: ''
        });        
      }
    };
  
    return (
      <Box>
        <TextField
          fullWidth
          label={t("e-mail")}
          //placeholder={t("Enter e-mail")}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={{ pt: 2 }}
        />
        <Button 
          variant="contained" 
          onClick={checkEmail} 
          sx={{ mt: 2 }}
        >{t("Add User")}
        </Button>
      </Box>
    );
};

export default Room;
